// Module
var code = `<h1>Партнёрский трафик</h1> <h3 class="metric-meaning">Что значит?</h3><p>Трафик по партнёрским (реферальным) ссылкам и промокодам, когда партнёры получают комиссию за приведённых на сайт пользователей.</p> `;
// Exports
module.exports = code;